import { sendLogInCred, getSubUser, getLoginRoleDetails } from "shared/api";

import { AUTH_SUCCESS, AUTH_FAIL, AUTH_START, SIGN_OUT } from "./authTypes";
import { ROLE } from "redux/actions/role/roleTypes";

export const signIn = (data) => async (dispatch) => {

  dispatch({
    type: AUTH_START,
  });

  try {
    const res = await sendLogInCred(data);

    const userData = await getSubUser(res.data.token);

    let user = userData.data.data.subuser;

    user["token"] = res.data.token;
    let roles = await getLoginRoleDetails(user["role_reference_number"], res.data.token);

    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("role", JSON.stringify(roles["data"]["data"]));

    dispatch({
      type: ROLE,
      payload: user,
    });

    dispatch({
      type: AUTH_SUCCESS,
      payload: { user: user },
    });
    return true;
  } catch (err) {
    dispatch({
      type: AUTH_FAIL,
    });
    return false;
  }
};

export const signOut = (_) => async (dispatch) => {
  try {
    // localStorage.removeItem("user");
    // localStorage.removeItem("role");
    localStorage.clear();
    dispatch({
      type: SIGN_OUT,
    });
  } catch (error) {
    console.error(error);
  }
};
